export default {"src":"/_next/static/media/artifact.a7ad4ffd.svg","height":850,"width":600,"blurWidth":0,"blurHeight":0};